// extracted by mini-css-extract-plugin
export default {"container":"ProgressBar_container__VBzqp","item":"ProgressBar_item__7mQMQ","text":"ProgressBar_text__VzOPO","reached":"ProgressBar_reached__Ha5aM"};